var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserOutlinedIcon = function SvgUserOutlinedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
    fill: "#currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.267 13.582c-1.082.468-2.845.918-4.267.918-1.55 0-3.638-.77-4.65-1.236-.408-.187-.456-.535-.144-.857A6.65 6.65 0 0 1 8 10.357c1.695 0 3.245.642 4.43 1.7.55.49.515 1.232-.163 1.525ZM8 8.643c1.394 0 2.524-1.151 2.524-2.572C10.524 4.651 9.394 3.5 8 3.5c-1.394 0-2.524 1.151-2.524 2.571 0 1.42 1.13 2.572 2.524 2.572Z",
    fill: "#currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.367 13.812c-1.108.479-2.905.938-4.367.938-.81 0-1.746-.2-2.598-.454a17.13 17.13 0 0 1-2.156-.805c-.251-.115-.443-.305-.485-.565-.04-.256.077-.499.265-.693A6.9 6.9 0 0 1 8 10.107a6.88 6.88 0 0 1 4.597 1.763c.322.288.494.67.461 1.046-.034.384-.278.716-.691.896Zm-1.593-7.74c0 1.553-1.238 2.82-2.774 2.82s-2.774-1.267-2.774-2.82C5.226 4.517 6.464 3.25 8 3.25s2.774 1.268 2.774 2.821Zm-.25 0c0 1.42-1.13 2.57-2.524 2.57-1.394 0-2.524-1.15-2.524-2.57S6.606 3.5 8 3.5c1.394 0 2.524 1.151 2.524 2.571ZM8 14.5c1.422 0 3.184-.45 4.267-.918.678-.293.713-1.034.163-1.526A6.631 6.631 0 0 0 8 10.357a6.65 6.65 0 0 0-4.794 2.05c-.312.322-.264.67.144.857C4.362 13.73 6.45 14.5 8 14.5Z",
    fill: "#currentColor"
  })));
};

export default SvgUserOutlinedIcon;